import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canManageAnyBookableAsset } from "@/helpers/permissions";
import { canViewSchedule } from "@/modules/bookings/permissions";

import { AssetDetailPage } from "./pages/asset-detail/AssetDetailPage";
import { CreateBookableAssetPage } from "./pages/bookable-asset-editor/CreateBookableAssetPage";
import { EditBookableAssetPage } from "./pages/bookable-asset-editor/EditBookableAssetPage";
import { CreateBookingPage } from "./pages/booking-editor/CreateBookingPage";
import { EditBookingPage } from "./pages/booking-editor/EditBookingPage";
import { BookableAssetOverviewPage } from "./pages/list-assets/BookableAssetOverviewPage";
import { bookingsRoutes } from "./routes";

export const bookingsRoute = [
  {
    path: bookingsRoutes.list,
    element: <BookableAssetOverviewPage />,
  },
  {
    path: bookingsRoutes.assetDetail,
    element: (
      <RequireAuth permission={canViewSchedule}>
        <AssetDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: bookingsRoutes.createAsset,
    element: (
      <RequireAuth permission={canManageAnyBookableAsset}>
        <CreateBookableAssetPage />
      </RequireAuth>
    ),
  },
  {
    path: bookingsRoutes.editAsset,
    element: (
      <RequireAuth permission={canManageAnyBookableAsset}>
        <EditBookableAssetPage />
      </RequireAuth>
    ),
  },
  {
    path: bookingsRoutes.bookAsset,
    element: <CreateBookingPage />,
  },
  {
    path: bookingsRoutes.editBooking,
    element: <EditBookingPage />,
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
